export enum AspectRatioVariant {
  billAttachment = '1/1.41',
}
